import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postBillingSettings = async (nickname, permissions) => {
  const apiURL = API_HOST + '/settings/billing';
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.post(apiURL,{},{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
      }
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
